import { build, set } from 'shared/set';
import { isObjectType } from 'utils/is';

export default function blcktive$set(keypath, value, options) {
  const blcktive = this;

  const opts = isObjectType(keypath) ? value : options;

  return set(build(blcktive, keypath, value, opts && opts.isolated), opts);
}
